export enum Portal {
    MOCK = "MOCK",
    GAME_DISTRIBUTION = "GAME_DISTRIBUTION",
    GAMEPIX = "GAMEPIX",
    CRAZYGAMES = "CRAZYGAMES",
    GAME_MONETIZE = "GAME_MONETIZE",
    POKI = "POKI",
    PLAYGAMA = "PLAYGAMA",
}

export type PortalSDKArgs = {
    portal: Portal;
    pauseGame: () => void;
    resumeGame: () => void;
    muteGame: () => void;
    unmuteGame: () => void;
    onInit: () => void;
};

export abstract class PortalSDK {
    public static sharedInstance: PortalSDK | null = null;

    protected _args: PortalSDKArgs;
    protected _rewardedAdReady: boolean = false;
    get RewardedAdReady() {
        return this._rewardedAdReady;
    }

    get Portal() {
        return this._args.portal;
    }

    constructor(args: PortalSDKArgs) {
        this._args = args;
        // window.addEventListener("keydown", (event) => {
        //     if (["ArrowUp", "ArrowDown", " "].includes(event.key)) {
        //         event.preventDefault();
        //     }
        // });
        // window.addEventListener("wheel", (event) => event.preventDefault(), {
        //     passive: false,
        // });
    }

    message(m: PortalSDKMessage) {
        if (m.only) {
            if (!m.only.includes(this._args.portal)) {
                m.portalSkipped?.();
                return;
            }
        }
        if (m.except) {
            if (m.except.includes(this._args.portal)) {
                m.portalSkipped?.();
                return;
            }
        }
        this._sdkMessage(m);
    }

    protected _pauseAndMuteGame(): void {
        this._args.pauseGame();
        this._args.muteGame();
    }

    protected _resumeAndUnmuteGame(): void {
        this._args.resumeGame();
        this._args.unmuteGame();
    }

    protected abstract _sdkMessage(m: PortalSDKMessage): void;
}

export type PortalSDKMessageBase = {
    only?: Portal[];
    except?: Portal[];
    portalSkipped?: () => void;
};

export type PortalSDKShowAdMessage = PortalSDKMessageBase & {
    type: "showAd";
    callback: () => void;
};
export type PortalSDKShowRewardedAdMessage = PortalSDKMessageBase & {
    type: "showRewardedAd";
    callback: (success: boolean) => void;
};
export type PortalSDKUpdateScoreMessage = PortalSDKMessageBase & {
    type: "updateScore";
    score: number;
};
export type PortalSDKUpdateLevelMessage = PortalSDKMessageBase & {
    type: "updateLevel";
    level: number;
};
export type PortalSDKGameplayStart = PortalSDKMessageBase & {
    type: "gameplayStart";
};
export type PortalSDKGameplayStop = PortalSDKMessageBase & {
    type: "gameplayStop";
};
export type PortalSDKLoadingStart = PortalSDKMessageBase & {
    type: "loadingStart";
};
export type PortalSDKLoadingStop = PortalSDKMessageBase & {
    type: "loadingStop";
};
export type PortalSDKDataClear = PortalSDKMessageBase & {
    type: "dataClear";
};
export type PortalSDKDataGetItem = PortalSDKMessageBase & {
    type: "dataGetItem";
    key: string;
    callback: (value: any) => void;
};
export type PortalSDKDataRemoveItem = PortalSDKMessageBase & {
    type: "dataRemoveItem";
    key: string;
};
export type PortalSDKDataSetItem = PortalSDKMessageBase & {
    type: "dataSetItem";
    key: string;
    value: string;
};

export type PortalSDKMessage =
    | PortalSDKShowAdMessage
    | PortalSDKShowRewardedAdMessage
    | PortalSDKUpdateScoreMessage
    | PortalSDKUpdateLevelMessage
    | PortalSDKGameplayStart
    | PortalSDKGameplayStop
    | PortalSDKLoadingStart
    | PortalSDKLoadingStop
    | PortalSDKDataClear
    | PortalSDKDataGetItem
    | PortalSDKDataRemoveItem
    | PortalSDKDataSetItem;
